import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";
import { SupplierTable } from "@/app/Suppliers/Components/SupplierTable";
import { useTranslations } from "use-intl";

export function SupplierTableScreen() {
  const t = useTranslations("supplier");

  return (
    <FullPageScreen>
      <h3 className="pb-2.5 text-base font-semibold leading-6 text-gray-900">
        {t("suppliers")}
      </h3>
      <SupplierTable id="suppliers" />
    </FullPageScreen>
  );
}
